import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';
import { LogIn, Sparkles, Layout, Palette } from 'lucide-react';

const AdminLogin = () => {
  const { login, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#1a1c1b] flex items-center justify-center">
        <div className="text-[#7dd3fc]">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#1a1c1b] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <a href="/" className="inline-flex items-center gap-2 mb-6">
            <span className="text-[#7dd3fc] font-black text-3xl tracking-tight">RDK</span>
            <span className="text-white font-medium text-xl">Services</span>
          </a>
          <h1 className="text-[#7dd3fc] font-bold text-2xl mb-2">Admin Dashboard</h1>
          <p className="text-[#888680]">AI-Powered Website Builder</p>
        </div>

        {/* Features */}
        <div className="bg-[#302f2c] border border-[#1e3a5f]/50 rounded-lg p-6 mb-6">
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-[#1e3a5f] rounded-lg flex items-center justify-center flex-shrink-0">
                <Sparkles className="w-5 h-5 text-[#7dd3fc]" />
              </div>
              <div>
                <h3 className="text-[#7dd3fc] font-semibold">AI Website Generation</h3>
                <p className="text-[#888680] text-sm">Describe your website and let AI build it for you</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-[#1e3a5f] rounded-lg flex items-center justify-center flex-shrink-0">
                <Layout className="w-5 h-5 text-[#7dd3fc]" />
              </div>
              <div>
                <h3 className="text-[#7dd3fc] font-semibold">Visual Editor</h3>
                <p className="text-[#888680] text-sm">Fine-tune every section with drag-and-drop</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-[#1e3a5f] rounded-lg flex items-center justify-center flex-shrink-0">
                <Palette className="w-5 h-5 text-[#7dd3fc]" />
              </div>
              <div>
                <h3 className="text-[#7dd3fc] font-semibold">Custom Styling</h3>
                <p className="text-[#888680] text-sm">Full control over colors, fonts, and layouts</p>
              </div>
            </div>
          </div>
        </div>

        {/* Login Button */}
        <Button
          onClick={login}
          className="w-full bg-[#7dd3fc] text-[#1a1c1b] hover:bg-[#7dd3fc]/90 rounded-full px-8 py-6 font-semibold uppercase tracking-wide text-base transition-transform hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2"
        >
          <LogIn size={20} />
          Sign in with Google
        </Button>

        <p className="text-center text-[#888680] text-sm mt-4">
          By signing in, you agree to our Terms of Service
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
